import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "submit"]

  connect() {
    this.bindSubmitSync()
    this.updateHidden()
    this.inputTargets.forEach((input, index) => {
      input.addEventListener('keydown', (e) => this.handleKeyDown(e, index))
      input.addEventListener('input', (e) => this.handleInput(e, index))
      input.addEventListener('paste', (e) => this.handlePaste(e))
    })
  }

  handleKeyDown(e, index) {
    if (e.key === "Backspace" && e.target.value === "") {
      if (index > 0) {
        this.inputTargets[index - 1].focus()
      }
    } else if (e.key === "ArrowLeft") {
      if (index > 0) this.inputTargets[index - 1].focus()
    } else if (e.key === "ArrowRight") {
      if (index < this.inputTargets.length - 1) this.inputTargets[index + 1].focus()
    }
  }

  handleInput(e, index) {
    const digits = e.target.value.replace(/\D/g, '')

    if (digits.length > 1) {
      this.fillFrom(index, digits)
      return
    }

    e.target.value = digits

    if (digits !== "" && index < this.inputTargets.length - 1) {
      this.inputTargets[index + 1].focus()
    }

    this.updateHidden()
  }

  handlePaste(e) {
    e.preventDefault()
    const paste = (e.clipboardData || window.clipboardData).getData('text')
    const digits = (paste.match(/\d/g) || []).join('')
    if (digits.length === 0) return

    this.fillFrom(0, digits)
  }

  fillFrom(startIndex, rawDigits) {
    const digits = rawDigits.toString().replace(/\D/g, '').slice(0, this.inputTargets.length - startIndex)
    if (digits.length === 0) return

    digits.split('').forEach((digit, offset) => {
      const target = this.inputTargets[startIndex + offset]
      if (target) target.value = digit
    })

    const lastFilledIndex = startIndex + digits.length - 1
    if (lastFilledIndex >= 0 && lastFilledIndex < this.inputTargets.length - 1) {
      this.inputTargets[lastFilledIndex + 1].focus()
    } else if (lastFilledIndex >= this.inputTargets.length - 1) {
      this.inputTargets[this.inputTargets.length - 1].blur()
    }

    this.updateHidden()
  }

  bindSubmitSync() {
    this.form = this.element.closest('form')
    if (!this.form) return

    this.submitHandler = () => this.updateHidden()
    this.form.addEventListener('submit', this.submitHandler)
  }

  disconnect() {
    if (this.form && this.submitHandler) {
      this.form.removeEventListener('submit', this.submitHandler)
    }
  }

  updateHidden() {
    const otp = this.inputTargets.map(i => i.value).join('')
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = otp
    }
    this.updateSubmitState()
  }

  updateSubmitState() {
    if (!this.hasSubmitTarget) return

    const complete = this.inputTargets.every((input) => /^\d$/.test(input.value))
    this.submitTarget.disabled = !complete
    this.submitTarget.setAttribute('aria-disabled', (!complete).toString())
    this.submitTarget.classList.toggle('opacity-50', !complete)
    this.submitTarget.classList.toggle('cursor-not-allowed', !complete)
  }
}
